import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTriumphPayTxDetail extends Layout {
    checkboxTriumphpayQuickpay: Checkbox;
    labelQuickPay: Label;
    labelTriumphpayQuickpay: Label;
    panelQuickPay: Panel;
    sourceSettlement: DataSource;
    textboxInvoiceStatusReason: Textbox;
    textboxTriumphpayCarrierpayDate: Textbox;
    textboxTriumphpayConfirmCode: Textbox;
    textboxTriumphpayInvoiceStatus: Textbox;
    textboxTriumphpayProcessDate: Textbox;
    textboxTriumphpayPymtDetails: Textbox;
    textboxTriumphpayPymtId: Textbox;
    textboxTriumphpayPymtStatus: Textbox;
    textboxTriumphpayTransactionDate: Textbox;
    textboxTriumphpayTransactionNum: Textbox;
}
